import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslatedBundleGuard } from '@dia/dialog-reusable-components';
import { CreateNotificationComponent } from './create-notification.component';
import { NotificationDocComponent } from './notification-doc/notification-doc.component';

import { MessageAttachmentComponent } from './message-attachment/message-attachment.component';
import { ConfigureFeedbackComponent } from './configure-feedback/configure-feedback.component';
import { DueDateReminderComponent } from './due-date-reminder/due-date-reminder.component';

const routes: Routes = [
  // {
  //   path: '',
  //   component: CreateNotificationComponent,
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: '/notification-doc',
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: 'notification-doc',
  //       component: NotificationDocComponent,
  //       canActivate: [TranslatedBundleGuard],
  //       data: { trackWithAnalytics: true }
  //     },
  //     {
  //       path: 'recipients',
  //       component: RecipientsComponent,
  //       canActivate: [TranslatedBundleGuard],
  //       data: { trackWithAnalytics: true }
  //     },
  //     {
  //       path: 'message-attachment',
  //       component: MessageAttachmentComponent,
  //       canActivate: [TranslatedBundleGuard],
  //       data: { trackWithAnalytics: true }
  //     },
  //     {
  //       path: 'configure-feedback',
  //       component: ConfigureFeedbackComponent,
  //       canActivate: [TranslatedBundleGuard],
  //       data: { trackWithAnalytics: true }
  //     },
  //     {
  //       path: 'due-date-reminder',
  //       component: DueDateReminderComponent,
  //       canActivate: [TranslatedBundleGuard],
  //       data: { trackWithAnalytics: true }
  //     },
  //     {
  //       path: '**',
  //       redirectTo: '/create-notification',
  //       pathMatch: 'full'
  //     }
  //   ]
  // },
  // {
  //   path: '**',
  //   redirectTo: '/create-notification',
  //   pathMatch: 'full'
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateNotificationRoutingModule {}
